import { Injectable } from '@angular/core';
import { QuotationCommercialItem } from 'projects/dop-ordering/src/lib/models/quotable-items/quotation-commercial-item.model';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class SubgroupPlanningLineRule {

    constructor(private quotationCommercialItem: QuotationCommercialItem) { }

    isSGTestApplicable(subgroupCode: string, ciCode: string): CommercialItemValidationResponse {
        let isValid = true;
        if (subgroupCode) {
            isValid = this.quotationCommercialItem?.commercialItemSubGroups?.filter(c => c.code === subgroupCode).shift()
                .testQuotationLines.some(t => t.code === ciCode);
        }
        {
            isValid = this.quotationCommercialItem?.commercialItemSubGroups?.some(c => c.testQuotationLines.some(t => t.code === ciCode));
        }
        return {
            isValid,
        };
    }

    isSGPackageApplicable(subgroupCode: string, ciCode: string): CommercialItemValidationResponse {
        let isValid = true;
        isValid = this.quotationCommercialItem?.commercialItemSubGroups?.filter(c => c.code === subgroupCode).shift()
            .packageQuotationLines.some(p => p.code === ciCode);
        return {
            isValid,
        };
    }

    isSubgroupApplicable(subgroupCode: string): CommercialItemValidationResponse {
        let isValid = true;
        isValid = this.quotationCommercialItem?.commercialItemSubGroups?.some(c => c.code === subgroupCode);
        return {
            isValid,
        };
    }

}
